import _ from 'lodash';

export default class ProductInventory {
  constructor(data) {
    // It's a good practice to use lodash getters
    this.productId = _.get(data, 'productId');
    this.storeId = _.get(data, 'storeId');
    this.inventoryId = _.get(data, 'inventoryId');
    // this.dateBegin = _.get(data, 'dateBegin');
    // this.dateEnd = _.get(data, 'dateEnd');
    this.name = _.get(data, 'name');
    this.nameDisplayed = _.get(data, 'nameDisplayed');
    this.unit = _.get(data, 'unit');
    this.family = _.get(data, 'family');
    const checkDefault = (v, def) => (v == null ? def : v);
    this.quantityAreaStock = checkDefault(_.get(data, 'quantityAreaStock', undefined), undefined);
    this.quantityAreaSelling = checkDefault(_.get(data, 'quantityAreaSelling', undefined), undefined);
    /*
    this.quantityAreaStock = _.get(data, 'quantityAreaStock');
    this.quantityAreaSelling = _.get(data, 'quantityAreaSelling');
    */
    this.quantityMin = _.get(data, 'quantityMin', 0);
    this.quantityMax = _.get(data, 'quantityMax', null);
    this.canBeEmpty = _.get(data, 'canBeEmpty', true);
    this.isInteger = _.get(data, 'isInteger', true);
    // const list = ['Autre', 'Epicerie'];
    // let displayAreaSelling = true;
    // if (_.indexOf(list, this.family) !== -1) {
    //   displayAreaSelling = false;
    // }
    // this.displayAreaSelling = displayAreaSelling;
    this.displayAreaSelling = _.get(data, 'displayAreaSelling', false);
    this.priority = _.get(data, 'priority', false);
    this.recommandation = _.get(data, 'recommandation', '');
    this.average = _.get(data, 'average', null);
    this.highlightName = _.get(data, 'highlightName', false);
    this.highlightPackaging = _.get(data, 'highlightPackaging', false);
  }

  get displayName() {
    return this.name;
  }

  get displayUnit() {
    return this.unit;
  }

  /*
  get displayAreaSelling() {
    const list = ['Autre', 'Epicerie'];
    if (_.indexOf(list, this.family) !== -1) {
      return false;
    }
    return true;
  }
  */

  get displayTotal() {
    const quantityAreaStock = parseFloat(_.get(this, 'quantityAreaStock', 0));
    const quantityAreaSelling = parseFloat(_.get(this, 'quantityAreaSelling', 0));

    const result = quantityAreaStock + quantityAreaSelling;
    return result;
  }
}
